import { render, staticRenderFns } from "./eye_massage.vue?vue&type=template&id=7f3f3f23&scoped=true&"
import script from "./eye_massage.vue?vue&type=script&lang=js&"
export * from "./eye_massage.vue?vue&type=script&lang=js&"
import style0 from "./eye_massage.vue?vue&type=style&index=0&id=7f3f3f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3f3f23",
  null
  
)

export default component.exports